import { useQuery } from '@tanstack/react-query';
import api from '@/lib/axios';
import { useAuthStore, ROL } from '@/store/auth.store';
import { SuscripcionBlockModal } from './SuscripcionBlockModal';

/**
 * Se monta una sola vez en el layout autenticado.
 * SuperAdmin tiene acceso irrestricto (necesita entrar para activar la licencia).
 * Para el resto, bloquea la UI si el dominio no es válido o la licencia expiró.
 */
export function SuscripcionGuard() {
  const usuario     = useAuthStore(s => s.usuario);
  const esSuperAdmin = usuario?.rolId === ROL.SUPER_ADMIN;

  const { data } = useQuery({
    queryKey: ['suscripcion-verificar'],
    queryFn:  () => api.get('/api/suscripcion/verificar').then(r => r.data),
    staleTime: 5 * 60 * 1000,
    retry:     false,
    enabled:   !esSuperAdmin,
  });

  if (esSuperAdmin || !data) return null;

  const sinRegistro      = data.error === 'SIN_REGISTRO_LOCAL';
  const dominioBloqueado = data.dominioVerificacion?.valido === false;
  const licenciaExpirada = data.neej?.status === 'EXPIRADA' || data.neej?.status === 'INACTIVA';

  if (!sinRegistro && !dominioBloqueado && !licenciaExpirada) return null;

  const razon = sinRegistro
    ? 'SIN_REGISTRO'
    : dominioBloqueado ? 'DOMINIO_INVALIDO' : (data.neej?.status ?? 'EXPIRADA');
  return <SuscripcionBlockModal razon={razon} />;
}
